import React, { useState } from "react";
import { useLocation } from "react-router-dom";
// components
import WarningPopup from "../WarningPopup";
import VisibilitySensor from "react-visibility-sensor";
// images
import see_more from "../../assets/images/see_more.png";
import logo from "../../assets/images/ljpc_logo.png";
// styles
import styles from "./Footer.module.css";

export default function Footer() {
  let location = useLocation();
  const showPopup = location.pathname.includes("popup");
  const [modalOpen, setModalOpen] = useState(showPopup);
  const [safetyVisible, setSafetyVisible] = useState(false);

  const openWarning = () => {
    setModalOpen(true);
  };

  const handleVisibilityChange = (isVisible) => {
    setSafetyVisible(isVisible);
  };

  return window.location.pathname.match(/^\/admin/) ||
    window.location.pathname.match(/^\/login/) ? null : (
    <div className={`${styles.container}`}>
      <WarningPopup isOpen={modalOpen} setIsOpen={setModalOpen} />
      <div
        className={`${styles.floatingBox} ${
          safetyVisible ? styles.hideBox : ""
        }`}
        onClick={openWarning}
      >
        <div className={styles.boxTitle}>IMPORTANT SAFETY INFORMATION</div>
        <div className={styles.boxShowMore}>
          SEE MORE
          <img src={see_more} alt="open" className={styles.showMoreImage} />
        </div>
        <div style={{ clear: "both" }}></div>
        <div className={styles.boxInfo}>
          There is a potential for venous and arterial thrombotic and
          thromboembolic events in patients who receive GIAPREZA. Use concurrent
          venous thromboembolism (VTE) prophylaxis.
        </div>
      </div>
      <VisibilitySensor onChange={handleVisibilityChange} partialVisibility>
        <div className={styles.safetyInfoBar}>
          <div className={styles.safetyInfo}>
            <div className={styles.safety}>IMPORTANT SAFETY INFORMATION</div>
            <div className={styles.info}>
              <p>
                <strong>Indication</strong>
              </p>
              <p>
                GIAPREZA (angiotensin II) increases blood pressure in adults
                with septic or other distributive shock.
              </p>
              <p>
                <strong>Contraindications</strong>
              </p>
              <p>None.</p>
              <p>
                <strong>Warnings and Precautions</strong>
              </p>
              <p>
                The safety of GIAPREZA was evaluated in 321 adults with septic
                or other distributive shock in a randomized, double-blind,
                placebo-controlled study, ATHOS-3. There was a higher incidence
                of arterial and venous thrombotic and thromboembolic events in
                patients who received GIAPREZA compared to placebo-treated
                patients in the ATHOS-3 study (13% vs. 5%). The major imbalance
                was in deep venous thromboses. Use concurrent venous
                thromboembolism (VTE) prophylaxis.
              </p>
              <p>
                <strong>Adverse Reactions</strong>
              </p>
              <p>
                The most common adverse reactions reported in greater than 10%
                of GIAPREZA-treated patients were thromboembolic events. Adverse
                reactions occurring in ≥4% of patients treated with GIAPREZA and
                ≥1.5% more often than placebo-treated patients in the ATHOS-3
                study were thromboembolic events (including deep vein
                thrombosis), thrombocytopenia, tachycardia, fungal infection,
                delirium, acidosis, hyperglycemia, and peripheral ischemia.
              </p>
              <p>
                <strong>Drug Interactions​</strong>
              </p>
              <p>
                Angiotensin converting enzyme (ACE) inhibitors may increase
                response to GIAPREZA. Angiotensin II receptor blockers (ARBs)
                may reduce response to GIAPREZA.
              </p>
              <p>
                <strong>
                  You are encouraged to report negative side eﬀects of
                  prescription drugs to the FDA. To report SUSPECTED ADVERSE
                  REACTIONS, please contact:
                </strong>
              </p>
              <p>
                La Jolla Pharmaceutical Company
                <br />
                <a href="tel:1-800-651-3861">1-800-651-3861</a>
                <br />
                <a href="mailto:medicalinformation@ljpc.com">
                  medicalinformation@ljpc.com
                </a>
              </p>
              <p>
                U.S. Food and Drug Administration
                <br />
                <a href="tel:1-800-332-1088">1-800-FDA-1088</a>
                <br />
                <a
                  href="www.fda.gov/medwatch"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.fda.gov/medwatch
                </a>
              </p>
              <p>
                <strong>For additional information, please see</strong>{" "}
                <a
                  href="https://firebasestorage.googleapis.com/v0/b/giapreza-db.appspot.com/o/prescribing%2FGIAPREZA.pdf?alt=media"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  GIAPREZA FDA prescribing information
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </VisibilitySensor>
      <div className={styles.bottomRow}>
        <div>
          <a
            href="https://giapreza.com/privacy-policy"
            className={`${styles.link} ${styles.privacy}`}
          >
            Privacy Notice
          </a>
          <a
            href="https://giapreza.com/terms-of-use"
            className={`${styles.link} ${styles.terms}`}
          >
            Terms of Use
          </a>
        </div>
        <a href="https://lajollapharmaceutical.com/">
          <img src={logo} alt="logo" className={styles.logo} />
        </a>
      </div>
    </div>
  );
}
